import { Size, Switch } from "@blueprintjs/core";
import { useCallback } from "react";
import { useLocalStorage } from "usehooks-ts";
import { LocalStorageKeys } from "@/src/enum/localstorage";

export default function SettingsHover(): JSX.Element {
    const [isEnabled, setIsEnabled] = useLocalStorage<boolean | null>(LocalStorageKeys.CountryHoverEffect, null);

    const onChange = useCallback(
        (event: React.FormEvent<HTMLInputElement>) => {
            setIsEnabled(
                event.currentTarget.checked,
            );
        },
        [setIsEnabled],
    );

    return (
        <div>
            <div><b>Country Hover:</b></div>
            <div>
                <Switch
                    checked={isEnabled ?? false}
                    size={Size.LARGE}
                    onChange={onChange}
                />
            </div>
        </div>
    );
}
